__turbopack_context__.v({
  "card": "product-card-module-scss-module__lbJ1pa__card",
  "compact": "product-card-module-scss-module__lbJ1pa__compact",
  "cost": "product-card-module-scss-module__lbJ1pa__cost",
  "media": "product-card-module-scss-module__lbJ1pa__media",
  "meta": "product-card-module-scss-module__lbJ1pa__meta",
  "name": "product-card-module-scss-module__lbJ1pa__name",
  "price": "product-card-module-scss-module__lbJ1pa__price",
  "thumb": "product-card-module-scss-module__lbJ1pa__thumb",
  "title": "product-card-module-scss-module__lbJ1pa__title",
  "unpriced": "product-card-module-scss-module__lbJ1pa__unpriced",
});
